import { flatMap, go, ippL, sel } from 'fxjs/es';
import axios from 'axios';
import { changeDpiBlob } from 'changedpi';

function makeName({ projection_id, up_c_s_id, size, quantity, is_name, is_png }, i) {
  return `${projection_id}_${up_c_s_id}_tAC3-Stand_${size}_(50x30)_${quantity}ea_Laser_Ness-${is_name ? 'Name' : 'Character'}-${i}.${is_png ? 'png' : 'svg'}`;
}

function toCm(px) {
  return Math.ceil((px / 300) * 2.54) * 10;
}
export const makePrintableFileFormatForNessFrame = ({
  frame_characters_with_cutline,
  projection_id,
  up_c_s_id,
  quantity,
}) => {
  return go(
    frame_characters_with_cutline,
    ippL,
    flatMap(async ([i, fc]) => {
      const idx = i + 1;
      const avatar_image_url = fc.avater.image_url;
      const avatar_cutline_url = fc.avater.cutline_url;
      const avatar_size = `${toCm(fc.avater.width)}x${toCm(fc.avater.height)}`;
      const nameTag_image_url = fc.nameTag.image_url;
      const nameTag_cutline_url = fc.nameTag.cutline_url;
      const [avatar_image, name_tag_image, avatar_cutline, name_tag_cutline] = await Promise.all([
        go(axios.get(`${avatar_image_url}?v=1`, { responseType: 'arraybuffer' }), sel('data')),
        go(axios.get(`${nameTag_image_url}?v=1`, { responseType: 'arraybuffer' }), sel('data')),
        go(axios.get(`${avatar_cutline_url}?v=1`, { responseType: 'arraybuffer' }), sel('data')),
        go(axios.get(`${nameTag_cutline_url}?v=1`, { responseType: 'arraybuffer' }), sel('data')),
      ]);
      await go(avatar_image, (buffer) => {
        const blob = new Blob([new Uint8Array(buffer)], { type: 'image/png' });
        return changeDpiBlob(blob, 300);
      });
      return [
        {
          file_name: makeName(
            {
              projection_id,
              up_c_s_id,
              size: avatar_size,
              quantity,
              is_name: false,
              is_png: true,
            },
            idx,
          ),
          canvas_blob: await go(avatar_image, (buffer) => {
            const blob = new Blob([new Uint8Array(buffer)], { type: 'image/png' });
            return changeDpiBlob(blob, 300);
          }),
          up_c_s_id,
        },
        {
          file_name: makeName(
            {
              projection_id,
              up_c_s_id,
              size: avatar_size,
              quantity,
              is_name: false,
              is_png: false,
            },
            idx,
          ),
          canvas_blob: new Blob([new Uint8Array(avatar_cutline)], { type: 'image/svg+xml' }),
          up_c_s_id,
        },
        {
          file_name: makeName(
            {
              projection_id,
              up_c_s_id,
              size: avatar_size,
              quantity,
              is_name: true,
              is_png: true,
            },
            idx,
          ),
          canvas_blob: await go(name_tag_image, (buffer) => {
            const blob = new Blob([new Uint8Array(buffer)], { type: 'image/png' });
            return changeDpiBlob(blob, 300);
          }),
          up_c_s_id,
        },
        {
          file_name: makeName(
            {
              projection_id,
              up_c_s_id,
              size: avatar_size,
              quantity,
              is_name: true,
              is_png: false,
            },
            idx,
          ),
          canvas_blob: new Blob([new Uint8Array(name_tag_cutline)], { type: 'image/svg+xml' }),
          up_c_s_id,
        },
      ];
    }),
  );
};
